import { Navigate, Outlet } from 'react-router-dom'

import { useSession } from '../auth/useSession'

/**
 * Sin primer cobro no hay servicio.
 *
 * No hay capa gratuita ni prueba: `trialing` es el hueco entre crear la cuenta y
 * cobrar la primera cuota (PLAN.md §12.5). Mientras dure, lo único que se puede
 * hacer es pagar.
 *
 * La barrera de verdad está en el backend —`Tenant::acceptsUploads()` rechaza
 * las subidas y `QuotaGuard` no cede—, así que esto no es seguridad sino
 * orientación: sin ella, el estudio recién registrado aterriza en una lista de
 * proyectos vacía donde todos los botones fallan, y no entiende por qué.
 *
 * `suspended` NO redirige: esa cuenta ya pagó alguna vez, tiene galerías vivas
 * y necesita seguir viendo su trabajo aunque no pueda subir más.
 */
export function RequireActiveAccount() {
  const { tenant } = useSession()

  if (tenant?.status === 'trialing') {
    return <Navigate to="/activar" replace />
  }

  return <Outlet />
}
